import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
export default function () {
  const requiresPayToView = function (discussion) {
    const tags = discussion.tags() || [];
    const ptvTags = tags.filter(tag => tag && tag.blomstraPtvProduct());
    return !discussion.blomstraPtvPaid() && ptvTags.length > 0;
  };
  const payToView = function (discussion) {
    const handler = new Handler('ptv', {
      discussion: discussion.id()
    });
    handler.checkout();
  };
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (app.session?.user && requiresPayToView(discussion)) {
      const operation = items.has('reply') ? items.setContent.bind(items) : items.add.bind(items);
      operation('reply', m(Button, {
        onclick: () => payToView(discussion),
        className: "Button Button--primary"
      }, app.translator.trans('floxum-payments.forum.pay-to-view.purchase-control')));
    }
  });
}